module.exports = __webpack_public_path__ + "img/icon.f7d6f93b.png";